import { isNil } from 'ramda';

export default isNil;
